import * as actions from "./actions/Aml.Actions";
import produce from "immer";

import _ from "underscore";
import {
  SET_SAVELEND_AML_GDRIVE_LINK_ERROR,
  SET_SAVELEND_AML_GDRIVE_LINK_REQUEST,
  SET_SAVELEND_AML_GDRIVE_LINK_SUCCESS,
} from "./commands/Aml.Commands";

let initialState = {
  warnings: {
    data: [],
    lsData: [],
    personalData: [],
    fetching: false,
    fetched: false,
    lsFetching: false,
    lsFetched: false,
    personalFetching: false,
    personalFetched: false,
  },
  rules: {
    data: [],
    fetching: false,
    fetched: false,
  },
  profile: {},
  investorNotes: {},
  borrowerNotes: {},
  gDriveLink: {
    sending: false,
    sent: false,
    error: null,
  },
};

const aml = (state = initialState, action) => {
  return produce(state, (draft) => {
    switch (action.type) {
      case actions.GET_AML_WARNINGS_REQUEST: {
        draft.warnings.fetching = true;
        break;
      }

      case actions.GET_LOANSTEP_AML_WARNINGS_REQUEST: {
        draft.warnings.lsFetching = true;
        break;
      }

      case actions.GET_AML_WARNINGS_SUCCESS: {
        draft.warnings.fetching = false;
        draft.warnings.fetched = true;
        draft.warnings.data = action.response;
        break;
      }

      case actions.GET_LOANSTEP_AML_WARNINGS_SUCCESS: {
        draft.warnings.lsFetching = false;
        draft.warnings.lfFetched = true;
        draft.warnings.lsData = action.response;
        break;
      }

      case actions.GET_AML_WARNINGS_ACTIONS_REQUEST: {
        const id = action.additionalData.AmlWarningId;
        const index = _.findIndex(draft.warnings.data, (item) => {
          return item.Id === id;
        });

        draft.warnings.data[index].actions = {
          ...draft.warnings.data[index].actions,
          fetching: true,
        };
        break;
      }

      case actions.GET_AML_WARNINGS_ACTIONS_SUCCESS: {
        const id = action.additionalData.AmlWarningId;
        const index = _.findIndex(draft.warnings.data, (item) => {
          return item.Id === id;
        });

        draft.warnings.data[index].actions = {
          fetching: false,
          fetched: true,
          data: action.response,
        };
        break;
      }

      case actions.GET_LOANSTEP_AML_WARNINGS_ACTIONS_SUCCESS: {
        const id = action.additionalData.AmlWarningId;
        const index = _.findIndex(draft.warnings.lsData, (item) => {
          return item.Id === id;
        });

        draft.warnings.lsData[index].actions = {
          fetching: false,
          fetched: true,
          data: action.response,
        };
        break;
      }

      case actions.GET_PERSONAL_AML_WARNINGS_REQUEST: {
        draft.warnings.personalFetching = true;
        break;
      }

      case actions.GET_PERSONAL_AML_WARNINGS_SUCCESS: {
        draft.warnings.personalFetching = false;
        draft.warnings.personalFetched = true;
        draft.warnings.personalData = action.response;
        break;
      }

      case actions.GET_PERSONAL_AML_WARNINGS_ERROR: {
        draft.warnings.personalFetching = false;
        break;
      }

      case actions.GET_AML_RULES_REQUEST: {
        draft.rules.fetching = true;
        break;
      }

      case actions.GET_AML_RULES_SUCCESS: {
        draft.rules.fetching = false;
        draft.rules.fetched = true;
        draft.rules.data = action.response;
        break;
      }

      case actions.SET_INVESTOR_AML_RISK_LEVEL_SUCCESS: {
        const investorId = action.dataSent.InvestorId;
        draft.profile[investorId].data.EffectiveRiskLevel =
          action.dataSent.RiskLevel;
        break;
      }

      case actions.SET_BORROWER_AML_RISK_LEVEL_SUCCESS: {
        const borrowerId = action.dataSent.BorrowerId;
        draft.profile[borrowerId].data.EffectiveRiskLevel =
          action.dataSent.RiskLevel;
        break;
      }

      case actions.GET_INVESTOR_AML_NOTES_SUCCESS: {
        const investorId = action.additionalData.investorId;
        const type = action.additionalData.type;
        const investor = action.response;
        const investorNotesByType = investor.Notes.filter(
          (x) => x.Type === type,
        );
        draft.investorNotes = {
          [investorId]: investorNotesByType,
        };
        break;
      }

      case actions.GET_BORROWER_AML_NOTES_SUCCESS: {
        const borrowerId = action.additionalData.borrowerId;
        const type = action.additionalData.type;
        const borrower = action.response;
        const borrowerNotesByType = borrower.Notes.filter(
          (x) => x.Type === type,
        );
        draft.borrowerNotes = {
          [borrowerId]: borrowerNotesByType,
        };
        break;
      }

      case SET_SAVELEND_AML_GDRIVE_LINK_REQUEST:
        draft.gDriveLink.sending = true;
        draft.gDriveLink.sent = false;
        draft.gDriveLink.error = null;
        break;

      case SET_SAVELEND_AML_GDRIVE_LINK_SUCCESS:
        draft.gDriveLink.sending = false;
        draft.gDriveLink.sent = true;
        break;

      case SET_SAVELEND_AML_GDRIVE_LINK_ERROR:
        draft.gDriveLink.sending = false;
        draft.gDriveLink.sent = false;
        draft.gDriveLink.error = action.error;
        break;

      default:
        return draft;
    }
  });
};

export default aml;
